module.exports = __webpack_public_path__ + "static/media/delete-tag.a7e16515.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/FAQ/assets/delete-tag.png
// module id = 926
// module chunks = 0